import {useGetQuery} from "../../services/erp-resource-api.service";

const useUiConfigs = (type: any, id: any) => {
    const {data} = useGetQuery({doc: type, name: id})
    return data ? data : {data: {}}
}

export default useUiConfigs